// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eab0352a","667":"c29b9821","977":"865031d6"}[chunkId] + ".chunk.js";
};